/* eslint-disable camelcase */
import axios from "axios";
import { toastr } from "react-redux-toastr";

import URL from "../config/api";
import { persistor } from "../store/store";

export const firstLoginDone = () => (dispatch, getState) => {
  const { user } = getState();
  const newUser = { ...user, first_login: false };
  dispatch({ type: "USER_LOGGED_IN", payload: newUser });
};

export const firstEmotionsDone = () => (dispatch, getState) => {
  const { user } = getState();
  const newUser = { ...user, emotions: false };
  dispatch({ type: "USER_LOGGED_IN", payload: newUser });
};

export const updateTokens = (newToken, newRefreshToken) => dispatch => {
  dispatch({
    type: "UPDATE_TOKENS",
    payload: {
      accessToken: newToken,
      refreshToken: newRefreshToken
    }
  });
};

export const login = user => {
  user.type = "username";

  return (dispatch, getState) => {
    dispatch({ type: "TRY_LOGIN", payload: true });

    axios
      .post(
        `${URL.api}login`,
        { ...user },
        {
          headers: {
            "Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then(resp => {
        if (resp.data.success) {
          let user = {
            user: resp.data.data.user,
            user_complememt: resp.data.data.user_complememt,
            user_modules: resp.data.data.user_modules,
            user_roles: resp.data.data.user_role,
            user_segments: resp.data.data.user_segments,
            token: resp.data.data.token,
            refresh_token: resp.data.data.refresh_token,
            first_login: resp.data.data.first_login,
            user_rotes: resp.data.data.user_rotes
          };
          let roles = user.user_roles[0];
          let user_role_active = {
            role_id: roles.role_id, // perfil
            role_name: roles.role_name, // perfil
            group_id: roles.group_id, // grupo
            group_name: roles.group_name, // grupo
            region_id: roles.region_id, // região
            region_name: roles.region_name, // região
            school_id: roles.school_id, // escola
            school_name: roles.school_name, // escola
            type: roles.type
          };

          dispatch({ type: "ACTIVE_ROLES", payload: user_role_active });
          dispatch({ type: "TRANSLATES", payload: resp.data.data.translation });
          dispatch({ type: "USER_LOGGED_IN", payload: user });
          return { token: user.token, roles: user_role_active };
        }
        toastr.error("Erro!", resp.data.error);
        return dispatch({ type: "ERROR_LOGIN", payload: resp.data.error });
      })
      .then(resp => {
        if (resp.token) {
          // {perfil} /{grupo}
          // 1- adm geral
          // 2- adm grupo
          // 3- adm regional
          // 4- adm escola

          // Redireciona aluno alagoas para o ADR
          // if (resp.roles.group_id === 86 && resp.roles.role_id === 7) {
          //   window.location.replace(
          //     `http://avaliacao.educandus.com.br:3000/external_auth?token=${resp.token}`
          //   );
          // }

          axios
            .get(
              `${URL.api}access/role/listRoleMenuGroup/${resp.roles.role_id}/${
                resp.roles.group_id === null ? 0 : resp.roles.group_id
              }`,
              {
                headers: {
                  authorization: `Bearer ${resp.token}`,
                  "Access-Control-Allow-Origin": "*"
                }
              }
            )
            .then(respData => {
              if (respData.data.success) {
                // Definir filtros de menu/rotas
                const menuFilters = [
                  {
                    // Filtro para Acompanhamento Pedagógico - OCULTAR quando NÃO atender às condições
                    condition: userRole =>
                      !(
                        (userRole.role_id === 6 && userRole.group_id === 28) ||
                        (userRole.role_id === 5 && userRole.group_id === 28) ||
                        (userRole.role_id === 4 && userRole.group_id === 28) ||
                        (userRole.role_id === 3 && userRole.group_id === 28) ||
                        userRole.role_id === 1 ||
                        (userRole.role_id === 2 && userRole.group_id === 28)
                      ),
                    menuIds: [137] // ID do menu "Acompanhamento"
                  }
                ];

                const filtered = applyMenuFilters(
                  respData.data.data.menu,
                  respData.data.data.routes,
                  resp.roles,
                  menuFilters
                );

                dispatch({
                  type: "MENU_STRUCTURE",
                  payload: filtered.menu
                });
                dispatch({
                  type: "ROUTES_STRUCTURE",
                  payload: filtered.routes
                });
              }
            })
            .then(() => {
              axios
                .get(
                  `${URL.api}access/role/listRoleMenu/${resp.roles.role_id}`,
                  { headers: { Authorization: `Bearer ${resp.token}` } }
                )
                .then(resp => {
                  if (resp.data.success) {
                    dispatch({
                      type: "SET_ROLE_MENU",
                      payload: resp.data.data
                    });
                  }
                });
            })
            .then(() => {
              axios
                .get(
                  `${URL.api}access/role/protectedRoute/${resp.roles.role_id}`,
                  { headers: { Authorization: `Bearer ${resp.token}` } }
                )
                .then(resp => {
                  if (resp.data.success) {
                    dispatch({
                      type: "USER_ROUTES",
                      payload: resp.data.data
                    });
                  }
                });
            })
            .then(() => {
              axios
                .get(
                  `${URL.api}access/role/protectedRoute/${resp.roles.role_id}`,
                  { headers: { Authorization: `Bearer ${resp.token}` } }
                )
                .then(resp => {
                  if (resp.data.success) {
                    dispatch({
                      type: "USER_ROUTES",
                      payload: resp.data.data
                    });
                  }
                });
            })
            .then(resp => {
              // const socket = socketIOClient(URL.node);
              // const { user } = getState().user;
              // socket.emit("userConnected", { id: user.id, name: user.name });
              // dispatch({ type: "SET_SOCKET", payload: socket });

              dispatch({ type: "LOGIN_ACT", payload: true });
              return dispatch({ type: "TRY_LOGIN", payload: false });
            });

          // LOG
          const obj = {
            action_id: 1,
            origin_id: 1,
            description: "Fez login na plataforma",
            url: window.location.href,
            school_id: resp?.roles.school_id
          };

          axios.post(`${URL.api}audict/log/insert`, obj, {
            headers: {
              authorization: `Bearer ${resp.token}`,
              "Access-Control-Allow-Origin": "*"
            }
          });
        } else {
          return dispatch({ type: "TRY_LOGIN", payload: false });
        }
      });
  };
};

export const externalLogin =
  (data, callback = () => null) =>
  (dispatch, getState) => {
    let user = {
      user: data.user,
      user_complememt: data.user_complememt,
      user_modules: data.user_modules,
      user_roles: data.user_role,
      user_segments: data.user_segments,
      token: data.token
    };

    let roles = user.user_roles[0];
    let user_role_active = {
      role_id: roles.role_id, // perfil
      role_name: roles.role_name, // perfil
      group_id: roles.group_id, // grupo
      group_name: roles.group_name, // grupo
      region_id: roles.region_id, // região
      region_name: roles.region_name, // região
      school_id: roles.school_id, // escola
      school_name: roles.school_name, // escola
      type: roles.type
    };

    dispatch({ type: "ACTIVE_ROLES", payload: user_role_active });
    dispatch({ type: "TRANSLATES", payload: user.translation });
    dispatch({ type: "USER_LOGGED_IN", payload: user });

    axios
      .get(
        `${URL.api}access/role/listRoleMenuGroup/${user_role_active.role_id}/${
          user_role_active.group_id === null ? 0 : user_role_active.group_id
        }`,
        {
          headers: {
            authorization: `Bearer ${user.token}`,
            "Access-Control-Allow-Origin": "*"
          }
        }
      )
      .then(resp => {
        if (resp.data.success) {
          // Definir filtros de menu/rotas
          const menuFilters = [
            {
              // Filtro para Acompanhamento Pedagógico - OCULTAR quando NÃO atender às condições
              condition: userRole =>
                !(
                  (userRole.role_id === 6 && userRole.group_id === 28) ||
                  (userRole.role_id === 5 && userRole.group_id === 28) ||
                  (userRole.role_id === 4 && userRole.group_id === 28) ||
                  (userRole.role_id === 3 && userRole.group_id === 28) ||
                  userRole.role_id === 1 ||
                  (userRole.role_id === 2 && userRole.group_id === 28)
                ),
              menuIds: [137] // ID do menu "Acompanhamento"
            }
          ];

          const filtered = applyMenuFilters(
            resp.data.data.menu,
            resp.data.data.routes,
            user_role_active,
            menuFilters
          );

          dispatch({ type: "MENU_STRUCTURE", payload: filtered.menu });
          dispatch({
            type: "ROUTES_STRUCTURE",
            payload: filtered.routes
          });
        }
      })
      .then(() => {
        axios
          .get(
            `${URL.api}access/role/listRoleMenu/${user_role_active.role_id}`,
            {
              headers: { Authorization: `Bearer ${user.token}` }
            }
          )
          .then(resp => {
            if (resp.data.success) {
              dispatch({ type: "SET_ROLE_MENU", payload: resp.data.data });

              callback();
            }
          });
      })
      .then(() => {
        axios
          .get(
            `${URL.api}access/role/protectedRoute/${user_role_active.role_id}`,
            {
              headers: { Authorization: `Bearer ${user.token}` }
            }
          )
          .then(resp => {
            if (resp.data.success) {
              dispatch({ type: "USER_ROUTES", payload: resp.data.data });

              callback();
            }
          });
      })
      .then(resp => {
        // const socket = socketIOClient(URL.node);
        // const { user } = getState().user;
        // socket.emit("userConnected", { id: user.id, name: user.name });
        // dispatch({ type: "SET_SOCKET", payload: socket });

        dispatch({ type: "LOGIN_ACT", payload: true });
        return dispatch({ type: "TRY_LOGIN", payload: false });
      });

    // LOG
    const obj = {
      action_id: 1,
      origin_id: 1,
      description: "Fez login na plataforma",
      url: window.location.href,
      school_id: user_role_active.school_id
    };

    axios.post(`${URL.api}audict/log/insert`, obj, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Access-Control-Allow-Origin": "*"
      }
    });
  };

export const getMenuItens =
  (user, roleId, groupId = 0) =>
  (dispatch, getState) => {
    axios
      .get(`${URL.api}access/role/listRoleMenuGroup/${roleId}/${groupId}`, {
        headers: { authorization: `Bearer ${user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          // Definir filtros de menu/rotas
          const menuFilters = [
            {
              // Filtro para Acompanhamento Pedagógico - OCULTAR quando NÃO atender às condições
              condition: userRole =>
                !(
                  (userRole.role_id === 6 && userRole.group_id === 28) ||
                  (userRole.role_id === 5 && userRole.group_id === 28) ||
                  (userRole.role_id === 4 && userRole.group_id === 28) ||
                  (userRole.role_id === 3 && userRole.group_id === 28) ||
                  userRole.role_id === 1 ||
                  (userRole.role_id === 2 && userRole.group_id === 28)
                ),
              menuIds: [137] // ID do menu "Acompanhamento"
            }
          ];

          const filtered = applyMenuFilters(
            resp.data.data.menu,
            resp.data.data.routes,
            { role_id: roleId, group_id: groupId },
            menuFilters
          );

          dispatch({ type: "MENU_STRUCTURE", payload: filtered.menu });
          dispatch({
            type: "ROUTES_STRUCTURE",
            payload: filtered.routes
          });
        }
      });
  };

export const languageGet = (id, token) => {
  let config = {
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`
    }
  };
  axios.get(`${URL.api}configuration/language/list/`, config).then(resp => {
    // if(resp.data.success){
    //     const user = resp.data.data
    //     return (dispatch({type: 'GET_PROFILE', payload: user}))
    // }
  });
};

export const logout = token => (dispatch, getState) => {
  let config = {
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`
    }
  };

  const logoutFn = () => {
    axios.get(`${URL.api}logout`, config).then(
      resp => {
        persistor.purge();

        const { socket } = getState();
        if (socket) socket.disconnect();
        dispatch({ type: "SET_SOCKET", payload: null });

        // Limpar filtros de revisão de questões
        localStorage.removeItem("questionBankReviewFilters");

        dispatch({ type: "LOGOFF_ACT", payload: false });

        // window.location.href = "/";
      },
      error => {
        persistor.purge();

        const { socket } = getState();
        if (socket) socket.disconnect();
        dispatch({ type: "SET_SOCKET", payload: null });

        // Limpar filtros de revisão de questões
        localStorage.removeItem("questionBankReviewFilters");

        dispatch({ type: "LOGOFF_ACT", payload: false });

        // window.location.href = "/";
      }
    );
  };

  const { general } = getState();
  let school_id = null;

  if (general) {
    const { active_roles } = general;
    if (active_roles) school_id = active_roles?.school_id;
  }

  // LOG
  const obj = {
    action_id: 2,
    origin_id: 1,
    description: "Fez logout na plataforma",
    url: window.location.href,
    school_id
  };

  axios.post(`${URL.api}audict/log/insert`, obj, config).then(
    () => {
      logoutFn();
    },
    () => {
      logoutFn();
    }
  );
};

export const changeRoles = roles => (dispatch, getState) => {
  dispatch({ type: "ACTIVE_ROLES", payload: roles });

  axios
    .get(
      `${URL.api}access/role/listRoleMenuGroup/${roles.role_id}/${
        roles.group_id === null ? 0 : roles.group_id
      }`,
      {
        headers: {
          authorization: `Bearer ${getState().user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    .then(resp => {
      if (resp.data.success) {
        // Definir filtros de menu/rotas
        const menuFilters = [
          {
            // Filtro para Acompanhamento Pedagógico - OCULTAR quando NÃO atender às condições
            condition: userRole =>
              !(
                (userRole.role_id === 6 && userRole.group_id === 28) ||
                (userRole.role_id === 5 && userRole.group_id === 28) ||
                (userRole.role_id === 4 && userRole.group_id === 28) ||
                (userRole.role_id === 3 && userRole.group_id === 28) ||
                userRole.role_id === 1 ||
                (userRole.role_id === 2 && userRole.group_id === 28)
              ),
            menuIds: [137] // ID do menu "Acompanhamento
          }
        ];

        const filtered = applyMenuFilters(
          resp.data.data.menu,
          resp.data.data.routes,
          roles,
          menuFilters
        );

        dispatch({ type: "MENU_STRUCTURE", payload: filtered.menu });
        dispatch({
          type: "ROUTES_STRUCTURE",
          payload: filtered.routes
        });
        window.location.reload();
      }
    });
};

export const tryLogin = isTrying => (dispatch, getState) =>
  dispatch({ type: "TRY_LOGIN", payload: isTrying });

export const updateUser =
  (callback = () => null) =>
  (dispatch, getState) => {
    axios
      .get(`${URL.api}access/user/singleView/${getState().user.user.id}`, {
        headers: { authorization: `Bearer ${getState().user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          const { user } = resp.data.data;
          dispatch({ type: "USER_UPDATED", payload: user });
          callback(user);
        }
      });
  };

/**
 * Função genérica para filtrar menus e rotas baseado em condições específicas
 * @param {Array} menu - Array do menu
 * @param {Array} routes - Array das rotas
 * @param {Object} userRole - Objeto com role_id e group_id do usuário
 * @param {Array} filters - Array de filtros a serem aplicados
 * @returns {Object} - Objeto com menu e rotas filtrados
 */
export const applyMenuFilters = (menu, routes, userRole, filters) => {
  let filteredMenu = [...menu];
  let filteredRoutes = [...routes];

  filters.forEach((filter, index) => {
    const shouldHide = filter.condition(userRole);

    if (shouldHide) {
      // Remover itens do menu
      if (filter.menuIds && filter.menuIds.length > 0) {
        filteredMenu = filteredMenu.map(menuItem => {
          if (menuItem.children) {
            menuItem.children = menuItem.children.filter(
              child => !filter.menuIds.includes(child.id)
            );
          }
          return menuItem;
        });
      }

      // Remover rotas
      if (filter.routeIds && filter.routeIds.length > 0) {
        filteredRoutes = filteredRoutes.filter(
          route => !filter.routeIds.includes(route.id)
        );
      }
    }
  });

  return { menu: filteredMenu, routes: filteredRoutes };
};

export const connectToSocket = () => (dispatch, getState) => {
  //   const socket = socketIOClient(URL.node);
  //   const { user } = getState().user;
  //   socket.emit("userConnected", { id: user.id, name: user.name });
  //   dispatch({ type: "SET_SOCKET", payload: socket });
};

export const disconnectToSocket = () => (dispatch, getState) => {
  const { socket } = getState();

  if (socket) socket.disconnect();

  dispatch({ type: "SET_SOCKET", payload: null });
};

// const mapStateToProps = state => ({user:state.user,form:state.form, general: state.general})
